import { useEffect } from "react";
import { Link } from "react-router-dom";
import { MarketingLayout } from "../components/MarketingLayout";
import { Check, GraduationCap, Zap, Heart } from "lucide-react";

var plans = [
  { name:"Tally Student", price:"Free", period:"forever", icon:GraduationCap, color:"#10b981", tag:"Under 25", features:["Bank syncing","Budget tracking","Bill reminders","AI insights","Net worth tracking"], cta:"Get started free", href:"/signup" },
  { name:"Tally Power", price:"$14.99", period:"/month", icon:Zap, color:"#7ED957", tag:"Most popular", featured:true, features:["Everything in Student","Cash flow forecasting","Advanced insights","Debt payoff planner","Priority support","7-day free trial"], cta:"Start 7-day free trial", href:"/signup" },
  { name:"Tally Senior", price:"Free", period:"forever", icon:Heart, color:"#8b5cf6", tag:"65+", features:["Bank syncing","Budget tracking","Bill reminders","AI insights","Simplified interface"], cta:"Get started free", href:"/signup" }
];

export const PricingPage = () => {
  // Page title & SEO handled globally by useSEO (utils/seo.js)
  return (
    <MarketingLayout>
      <style>{`
        .pr-hero { padding:64px 24px 48px; text-align:center; }
        .pr-hero h1 { font-family:'Lora',Georgia,serif; font-size:36px; font-weight:600; margin:0 0 12px; }
        .pr-hero p { font-size:17px; color:#6f6f64; max-width:480px; margin:0 auto; }
        .pr-grid { max-width:1000px; margin:0 auto 80px; padding:0 24px; display:grid; grid-template-columns:repeat(auto-fit,minmax(280px,1fr)); gap:24px; }
        .pr-card { background:#fff; border:1.5px solid #E8E2D5; border-radius:20px; padding:32px 28px; position:relative; transition:transform .2s,box-shadow .2s; }
        .pr-card:hover { transform:translateY(-4px); box-shadow:0 12px 40px rgba(20,67,43,.08); }
        .pr-card.featured { border-color:#7ED957; box-shadow:0 0 0 2px rgba(126,217,87,.15); }
        .pr-tag { display:inline-block; font-size:12px; font-weight:700; padding:4px 12px; border-radius:50px; margin-bottom:16px; }
        .pr-name { font-family:'Lora',Georgia,serif; font-size:20px; font-weight:600; margin:0 0 8px; }
        .pr-price { font-size:32px; font-weight:800; margin:0 0 4px; }
        .pr-price span { font-size:15px; font-weight:500; color:#6f6f64; }
        .pr-feats { list-style:none; padding:0; margin:24px 0; }
        .pr-feats li { display:flex; align-items:center; gap:10px; font-size:14px; color:#23241E; margin-bottom:10px; }
        .pr-cta { display:block; width:100%; height:48px; border:none; border-radius:50px; font-size:15px; font-weight:700; cursor:pointer; font-family:inherit; text-align:center; text-decoration:none; line-height:48px; transition:background .2s; }
        .pr-cta-primary { background:#14432B; color:#F4EFE4; }
        .pr-cta-primary:hover { background:#1a5838; }
        .pr-cta-outline { background:transparent; border:1.5px solid #E8E2D5; color:#23241E; }
        .pr-cta-outline:hover { border-color:#14432B; }
        .pr-note { text-align:center; padding:0 24px 80px; font-size:14px; color:#6f6f64; }
      `}</style>
      <div className="pr-hero">
        <h1>Simple, honest pricing</h1>
        <p>Free for students under 25 and seniors 65+. Everyone else gets a 7-day free trial.</p>
      </div>
      <div className="pr-grid">
        {plans.map(function(p,i){
          return (
            <div key={i} className={"pr-card" + (p.featured?" featured":"")}>
              <div className="pr-tag" style={{background:p.color+"18",color:p.color}}>{p.tag}</div>
              <h2 className="pr-name">{p.name}</h2>
              <p className="pr-price">{p.price}<span>{p.period}</span></p>
              <ul className="pr-feats">
                {p.features.map(function(f,j){return <li key={j}><Check size={16} style={{color:p.color,flexShrink:0}} />{f}</li>;})}
              </ul>
              <Link to={p.href} className={"pr-cta " + (p.featured?"pr-cta-primary":"pr-cta-outline")}>{p.cta}</Link>
            </div>
          );
        })}
      </div>
      <p className="pr-note">No credit card required to start. Cancel anytime.</p>
    </MarketingLayout>
  );
};
export default PricingPage;
